export default {
  methods: {
    handleGoBack() {
      this.$router.back();
    },
  },
};
